module.exports = __webpack_public_path__ + "static/img/connect_new_device.d35ff67.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/airplus_se/connect_new_device.gif
// module id = 8qJt
// module chunks = 1